module.exports = __webpack_public_path__ + "img/安息香.f56b5af8.jpg";